export function formatLocalPhone(e164) {
  if (!e164) return '-'

  const digits = e164.replace(/\D/g, '')

  // Take last 10 digits as local phone
  const local = digits.slice(-10)
  if (local.length !== 10) return e164

  return `(${local.slice(0,3)}) ${local.slice(3,6)}-${local.slice(6)}`
}